export enum OnepagerEntityType {
    Purpose = 'purpose',
    Ambition = 'ambition',
    TeamAmbition = 'teamAmbition',
    CVB = 'cvb',

    Pillar = 'pillar',
    PillarParent = 'pillarParent',
    PillarHeader = 'pillarHeader',
    PillarSuccessLook = 'pillarSuccessLook',

    Initiative = 'initiative',
    InitiativeHeader = 'initiativeHeader',
    InitiativeSuccessLook = 'initiativeSuccessLook',
    InitiativeTeam = 'initiativeTeam',

    Enabler = 'enabler',
    EnablerSuccessLook = 'enablerSuccessLook',
    EnablerTeam = 'enablerTeam',

    Comment = 'comment',

    // entities for ALTV2
    PillarCompany = 'pillarCompany',
    PillarTeam = 'pillarTeam',
    AmbitionCompany = 'ambitionCompany',
    AmbitionTeam = 'ambitionTeam'
}

export type OnepagerEntityIndex = {
    parentEntity?: OnepagerEntityType;
    parentEntityIndex?: number;
    entity: OnepagerEntityType;
    entityIndex?: number;
    attribute?: string;
    subEntityIndex?: number;
}
